import {
  Autocomplete,
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from '@mui/material';
import PropTypes from 'prop-types';
import * as React from 'react';
import { AREA_CATEGORY } from '../../constants/FieldsConst';
import { validFielddHelper } from '../../helpers/ValidFieldsHelper';
const AreaCategoriasField = ({
  onChange,
  required,
  value,
  helperText,
  error,
  isSearch,
  disabled = false,
  categorias,
}) => {
  const xName = 'Categoría';

  const xSearch = (
    <Autocomplete
      disablePortal
      id={'CATEGORI_SEACH'}
      options={categorias}
      size="small"
      onChange={onChange}
      getOptionLabel={(option) => option.label}
      value={value}
      disabled={disabled}
      renderInput={(params) => (
        <TextField
          fullWidth
          label={xName}
          helperText={helperText ?? error ? validFielddHelper(1) : null}
          error={error}
          required={required ?? true}
          {...params}
        />
      )}
    />
  );

  const xSelect = (
    <FormControl
      fullWidth
      error={error}
      size="small"
      required
      disabled={disabled}
    >
      <InputLabel id={AREA_CATEGORY}>{xName}</InputLabel>
      <Select
        labelId={AREA_CATEGORY}
        id={AREA_CATEGORY}
        value={value}
        label={xName}
        onChange={onChange}
      >
        {categorias.map((item) => {
          return (
            <MenuItem key={item.id} value={item.id}>
              {item.name}
            </MenuItem>
          );
        })}
      </Select>
      {error ? (
        <FormHelperText>
          {helperText ?? error ? validFielddHelper(1) : null}
        </FormHelperText>
      ) : (
        <></>
      )}
    </FormControl>
  );

  return isSearch ? xSearch : xSelect;
};

AreaCategoriasField.propTypes = {
  onChange: PropTypes.func.isRequired,
};

export default AreaCategoriasField;
